<p>file-browser-panel works!</p>
